import React from 'react';
import * as PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import theme from 'theme/theme';

const bounce = keyframes`
    0% {
        top: 75px;
        height: 5px;
        border-radius: 60px 60px 20px 20px;
        transform: scaleX(2);
    }
    35% {
        height: 25px;
        border-radius: 50%;
        transform: scaleX(1);
    }
    100% {
        top: 0;
    }
`;

const StyledWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    background: url(/images/background_mobian.jpg) no-repeat center bottom fixed;
    background-size: cover;
`;
const BouncingBall = styled.div`
    width: 25px;

    &::before {
        position: absolute;
        content: '';
        display: block;
        top: 0;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        background-color: ${ theme.palette.primary1Color };
        transform-origin: 50%;
        animation: ${ bounce } 500ms alternate infinite ease;
    };
`;

const StyledContent = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const StyledTitle = styled.div`
    margin: 30px 0 0 40px;
    color: ${ theme.palette.primary1Color };
    font-size: 50px;
`;

const LoadingScreen = () => {
    return (
        <StyledWrapper>
            <StyledContent>
                <BouncingBall />

                <StyledTitle>{ document.title }</StyledTitle>
            </StyledContent>
        </StyledWrapper>
    );
};

LoadingScreen.contextTypes = {
    theme: PropTypes.object,
};

export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/pages/LoadingScreen/index.js